import { motion } from "framer-motion";

export default function SectionHeading({
  eyebrow,
  title,
  titleAccent,
  subtitle,
  align = "center",
  dark = true,
}) {
  const alignClass = align === "left" ? "text-left" : "text-center mx-auto";

  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`mb-14 max-w-3xl ${alignClass}`}
    >
      {eyebrow ? (
        <div className={`mb-5 flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
          <span className="h-px w-10 bg-gradient-to-r from-accent to-transparent" aria-hidden />
          <p className="eyebrow-corporate">{eyebrow}</p>
          <span
            className={`h-px w-10 bg-gradient-to-l from-coral/80 to-transparent ${align === "left" ? "" : ""}`}
            aria-hidden
          />
        </div>
      ) : null}
      <h2 className={`title-editorial text-3xl sm:text-4xl lg:text-[2.75rem] ${dark ? "text-white" : "text-ink"}`}>
        {title}
        {titleAccent ? (
          <>
            {" "}
            <span className="italic text-gradient-coral">{titleAccent}</span>
          </>
        ) : null}
      </h2>
      {subtitle ? (
        <p
          className={`mt-5 font-sans text-base font-normal leading-relaxed sm:text-lg ${
            dark ? "text-corporate-slate" : "text-gray-600"
          }`}
        >
          {subtitle}
        </p>
      ) : null}
    </motion.div>
  );
}
